import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { sessionStorage } from '../localstorage.service';
import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent implements OnInit {
  count: any = [];
  distactive: boolean = false;
  ordersactive: boolean = false;
  masteractive: boolean = false;
  securityactive: boolean = false;
  piSystemActive: boolean = false;
  invMgmtActive: boolean = false;
  hrActive: boolean = false;
  itActive: boolean = false;
  shortcutActive: boolean = false;

  // Frontend-only file tools — koi backend permission flag nahi, sabhi logged-in users ko dikhte hain.
  shortcutTools = [
    { label: 'PDF Merge', link: '/shortcut/pdf-merge' },
    { label: 'Word to PDF', link: '/shortcut/word-to-pdf' }
  ];

  login_data: any = {};
  read: any = {};
  nexturl: any;
  tabType: 'Profile';

  constructor(public session: sessionStorage, public rout: Router, public route: ActivatedRoute, public serve: DatabaseService, private renderer: Renderer2, private router: Router, public dialog: DialogComponent) {
    this.tabType = 'Profile'
    this.login_data = this.session.getSession();
    this.login_data = this.login_data.value;
    this.login_data = this.login_data.data;
    this.serve.count_list();
    this.serve.dr_list();
    console.log(this.login_data, "line 45")
  }

  deferredPrompt: any = null;
  canInstall: boolean = false;

  ngOnInit() {
    // Mobile drawer aur desktop rail alag-alag states hain — dono ko kabhi
    // ek saath mat rakho, warna layout ke rules aapas me ladte hain.
    this.syncViewportState();

    // Capture the install prompt so we can trigger it from our own button
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstall = true;
    });
    window.addEventListener('appinstalled', () => {
      this.canInstall = false; this.deferredPrompt = null;
    });
  }

  installApp() {
    if (!this.deferredPrompt) return;
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then(() => {
      this.deferredPrompt = null;
      this.canInstall = false;
    });
  }

  // ── Drawer / rail state ───────────────────────────────────────────────────
  // `drawer-open`  -> mobile (<=820px) me slide-in drawer khula hai
  // `nav-active`   -> desktop par sidebar collapsed icon-rail me hai
  // Ye dono kabhi ek saath body par nahi hone chahiye.
  static readonly MOBILE_BP = 820;

  get isMobile(): boolean {
    return window.innerWidth <= NavigationComponent.MOBILE_BP;
  }

  get isDrawerOpen(): boolean {
    return document.body.classList.contains('drawer-open');
  }

  openDrawer() {
    this.renderer.addClass(document.body, 'drawer-open');
  }

  closeDrawer() {
    this.renderer.removeClass(document.body, 'drawer-open');
  }

  toggleDrawer() {
    if (this.isDrawerOpen) { this.closeDrawer(); } else { this.openDrawer(); }
  }

  @HostListener('window:resize')
  syncViewportState() {
    if (this.isMobile) {
      // Mobile par collapsed-rail ka koi matlab nahi — warna uske
      // padding/width rules drawer ke upar chad jaate hain.
      this.renderer.removeClass(document.body, 'nav-active');
    } else {
      this.closeDrawer();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.isDrawerOpen) { this.closeDrawer(); }
  }

  clearFilter() {
    let blank_data = {}
    this.serve.setData(blank_data);
    this.serve.count_list();
    this.serve.currentUserID = ''
    // On small screens, close the slide-in drawer as soon as a real page is opened
    this.closeDrawer();
  }

  toggleDropdown(value, event?: Event) {
    // Group header sirf submenu kholta hai — na navigate karta hai,
    // na drawer band karta hai. Isliye event yahin rok do.
    if (event) { event.preventDefault(); event.stopPropagation(); }

    // remember current state of the clicked group, then close all
    const prev = {
      1: this.distactive,
      2: this.ordersactive,
      3: this.masteractive,
      4: this.securityactive,
      5: this.piSystemActive,
      6: this.invMgmtActive,
      7: this.hrActive,
      8: this.itActive,
      9: this.shortcutActive
    };
    this.distactive = false;
    this.ordersactive = false;
    this.masteractive = false;
    this.securityactive = false;
    this.piSystemActive = false;
    this.invMgmtActive = false;
    this.hrActive = false;
    this.itActive = false;
    this.shortcutActive = false;

    // toggle only the clicked group (value 0 = plain link, just closes all)
    if (value == 1) { this.distactive = !prev[1]; }
    else if (value == 2) { this.ordersactive = !prev[2]; }
    else if (value == 3) { this.masteractive = !prev[3]; }
    else if (value == 4) { this.securityactive = !prev[4]; }
    else if (value == 5) { this.piSystemActive = !prev[5]; }
    else if (value == 6) { this.invMgmtActive = !prev[6]; }
    else if (value == 7) { this.hrActive = !prev[7]; }
    else if (value == 8) { this.itActive = !prev[8]; }
    else if (value == 9) { this.shortcutActive = !prev[9]; }
  }

  get isNavActive(): boolean {
    return document.body.classList.contains('nav-active');
  }

  toggleNav() {
    // Mobile par yehi button drawer kholta/band karta hai,
    // desktop par sidebar ko icon-rail me collapse karta hai.
    if (this.isMobile) {
      this.toggleDrawer();
      return;
    }
    if (this.isNavActive) {
      this.renderer.removeClass(document.body, 'nav-active');
    } else {
      this.renderer.addClass(document.body, 'nav-active');
    }
  }

  gotodmspages(tabtype) {
    this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/distribution-list/1/Channel%20Partner/distribution-detail/' + this.login_data['id'] + '/' + tabtype;
    this.router.navigate([this.nexturl]);
  }

  logout() {
    this.dialog.confirm('Logout').then((result) => {
      if (result) {
        this.session.LogOutSession();
        this.serve.datauser = {};
        this.rout.navigate(['']);
      }
    });
  }

}
